/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import RaiseQueryPopup from "../RaiseQuerypopup/RaiseQueryPopup.vue";
import moment from "moment";
export default {
    name: 'viewAlertDetailsPopup',
    components: {
        customModal,
        RaiseQueryPopup
    },
    props: {
        AlertId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            comments: "",
            alertDetails: [],
            alertItem: [],
            defaultdate:"",
            showRaiseQuery: false,
            querycountvar: "",
            roleprivileges:"",
        }
    },
    async mounted() {
        this.roleprivileges = store.getters.getRolesprivilegeData;
         this.defaultdate=localStorage.getItem("dateformat");
        await this.getAlerts();
    },
    methods: {

        filterDate(data) {
                if(data){
                return moment(data).format(this.defaultdate)
                }
            },
        relativeTime(data) {
                if (data) {
                    return moment(data).format('h:mm:ss');
                }
            },

        async getAlerts() {
            try {
                const token = store.getters.getIdToken;
                const response = await axios.get(
                    `${this.baseapi}/forms/alert/getaudits?Id=${this.AlertId}`,
                    { headers: { Authorization: "Bearer " + token } }
                );
                this.alertDetails = response.data.entities[0];
                this.alertItem = this.alertDetails.alertConfig;
                console.log("active alert is,", this.alertDetails)
            } catch (error) {
                console.error("Error fetching alerts:", error);
            }
        },

    }

};